<div class="report-container">

  <div class="report-header">
    <h2 class="report-title">Feedback</h2>
  </div>

  <p class="report-intro" *ngIf="!isSupervisor">
    Feedback left about probates you reported on. Only you can see this.
  </p>

  <!-- Filters -->
  <div class="filter-container">

    <mat-form-field appearance="outline" class="date-field">
      <mat-label>Date From</mat-label>
      <input matInput [matDatepicker]="pickerFrom" [(ngModel)]="dateFrom" (dateChange)="loadData()">
      <mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerFrom></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="date-field">
      <mat-label>Date To</mat-label>
      <input matInput [matDatepicker]="pickerTo" [(ngModel)]="dateTo" (dateChange)="loadData()">
      <mat-datepicker-toggle matIconSuffix [for]="pickerTo"></mat-datepicker-toggle>
      <mat-datepicker #pickerTo></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="search-field" *ngIf="isSupervisor">
      <mat-label>Data Complete User</mat-label>
      <mat-select [(ngModel)]="dataCompleteUserId" (selectionChange)="loadData()" placeholder="Select a user...">
        <mat-option *ngFor="let u of allUsers" [value]="u.id">{{ u.firstName }} {{ u.lastName }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Probate ID</mat-label>
      <input matInput [(ngModel)]="probateIdSearch" placeholder="Filter..." (keyup)="applyFilters()">
      <button *ngIf="probateIdSearch" matSuffix mat-icon-button (click)="probateIdSearch = ''; applyFilters()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Deceased Name</mat-label>
      <input matInput [(ngModel)]="deceasedNameSearch" placeholder="Filter..." (keyup)="applyFilters()">
      <button *ngIf="deceasedNameSearch" matSuffix mat-icon-button (click)="deceasedNameSearch = ''; applyFilters()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Reviewer</mat-label>
      <input matInput [(ngModel)]="reviewerSearch" placeholder="Filter..." (keyup)="applyFilters()">
      <button *ngIf="reviewerSearch" matSuffix mat-icon-button (click)="reviewerSearch = ''; applyFilters()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <button mat-button class="clear-btn"
            *ngIf="probateIdSearch || deceasedNameSearch || reviewerSearch || dateFrom || dateTo"
            (click)="clearFilters(); clearServerFilters()">Clear Filters</button>

    <span class="spacer"></span>

    <span class="results-count" *ngIf="!isSupervisor || dataCompleteUserId">{{ filteredGroups.length }} probate(s) found</span>

  </div>

  <ng-container *ngIf="isSupervisor && !dataCompleteUserId; else resultsTemplate">
    <div class="no-data-message">Select a Data Complete User above to view their feedback.</div>
  </ng-container>

  <ng-template #resultsTemplate>

    <!-- One real HTML table for the whole probate list - header (thead) and every group's summary
         + detail rows share ONE set of native table columns, so the browser guarantees they line
         up (this is exactly what already worked for the nested feedback-items-table below, from
         the very first attempt - a fake "table" built out of CSS Grid divs never reliably matched
         it, so the outer list is now a real table too, not a div-based grid. -->
    <table class="feedback-groups-table" *ngIf="pagedGroups.length > 0">
      <colgroup>
        <col class="fg-col-probateid">
        <col class="fg-col-deceasedname">
        <col class="fg-col-datacompletedate">
        <col class="fg-col-items">
        <col class="fg-col-reviewers">
        <col class="fg-col-dataapprovaluser">
        <col class="fg-col-expand">
      </colgroup>
      <thead>
        <tr>
          <th class="sortable" (click)="sortBy('probateId')">
            Probate ID <span class="sort-arrow" *ngIf="sortColumn === 'probateId'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
          </th>
          <th class="sortable" (click)="sortBy('deceasedName')">
            Deceased Name <span class="sort-arrow" *ngIf="sortColumn === 'deceasedName'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
          </th>
          <th class="sortable" (click)="sortBy('dataCompleteDate')">
            Data Complete Date <span class="sort-arrow" *ngIf="sortColumn === 'dataCompleteDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
          </th>
          <th class="sortable" (click)="sortBy('numberOfFeedbackItems')">
            Items <span class="sort-arrow" *ngIf="sortColumn === 'numberOfFeedbackItems'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
          </th>
          <th class="sortable" (click)="sortBy('reviewers')">
            Reviewer(s) <span class="sort-arrow" *ngIf="sortColumn === 'reviewers'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
          </th>
          <th class="sortable" (click)="sortBy('dataApprovalUser')">
            Data Approval User <span class="sort-arrow" *ngIf="sortColumn === 'dataApprovalUser'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody *ngFor="let group of pagedGroups">
        <tr class="group-summary-row" [class.expanded]="isExpanded(group.probateId)" (click)="toggleGroup(group.probateId)">
          <td>{{ group.probateId }}</td>
          <td>{{ group.deceasedName }}</td>
          <td>{{ formatDate(group.dataCompleteDate) }}</td>
          <td>{{ group.numberOfFeedbackItems }}</td>
          <td>{{ group.reviewers }}</td>
          <td>{{ group.dataApprovalUser }}</td>
          <td class="expand-icon">{{ isExpanded(group.probateId) ? '▲' : '▼' }}</td>
        </tr>
        <tr class="group-detail-row" *ngIf="isExpanded(group.probateId)">
          <td colspan="7">
            <table class="feedback-items-table">
              <colgroup>
                <col class="col-change">
                <col class="col-type">
                <col class="col-value">
                <col class="col-value">
                <col class="col-comments">
              </colgroup>
              <thead>
                <tr>
                  <th>Change</th>
                  <th>Feedback Type</th>
                  <th>Before</th>
                  <th>After</th>
                  <th>Comments</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of group.items">
                  <td [title]="item.bequestIdentifier || null" [class.has-identifier]="item.bequestIdentifier">{{ item.changeType ?? '-' }}</td>
                  <td>{{ item.feedbackTypeDescription }}</td>
                  <td class="value-cell">{{ item.beforeValue ?? '—' }}</td>
                  <td class="value-cell">{{ item.afterValue ?? '—' }}</td>
                  <td>{{ item.comments ?? '-' }}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="no-data-message" *ngIf="!loading && pagedGroups.length === 0">
      No feedback found for the selected criteria.
    </div>

    <mat-paginator #paginator
                   [length]="filteredGroups.length"
                   [pageSize]="pageSize"
                   [pageSizeOptions]="pageSizeOptions"
                   (page)="pageChanged($event)"
                   showFirstLastButtons>
    </mat-paginator>

  </ng-template>

</div>
